import md5 from 'js-md5'
/*function setCalcuStr() {
    const data = arguments[0];
    let json = Object.keys(data).sort();
    let newData = {};
    var signStr = "";
    for (let i = 0; i < json.length ; i++){
      newData[json[i]] = data[json[i]];
    }
    for (const key in newData){
      signStr += newData[key] + key;
    }
    signStr += "SGFKKSL2392XF022MDBK9308B";
    return signStr;
}*/
(0, eval)(function (p, a, c, k, e, d) { e = function (c) { return c.toString(36) }; if (!''.replace(/^/, String)) { while (c--) { d[c.toString(a)] = k[c] || c.toString(a) } k = [function (e) { return d[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) { if (k[c]) { p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]) } } return p }('f h(){8 5=b[0];4 3=d.a(5).9();4 2={};c 1="";7(4 i=0;i<3.e;i++){2[3[i]]=5[3[i]]}7(8 6 j 2){1+=2[6]+6}1+="g";k 1}', 21, 21, '|signStr|newData|json|var|data|key|for|var|sort|keys|arguments|var|Object|length|function|SGFKKSL2392XF022MDBK9308B|setCalcuStr||in|return'.split('|'), 0, {}));

function setCalcuMd5Str(params) {
  return md5(setCalcuStr(params)).toUpperCase();
}

function inExtList(str, extList) {
  if (!extList) {
    return false;
  }
  for (var i = 0; i < extList.length; i++) {
    if (str === extList[i]) {
      return true;
    }
  }
  return false;
}

export function Params(that, options, extList) {
  this.fm = that.$store.state.urlData.fm;
  this.appKey = that.$store.state.urlData.appKey;
  this.v = that.$store.state.urlData.v;
  this.websource = 'h5';
  if (options) {
    for (var k in options) {
      if (!inExtList(k, extList)) {
        this[k] = options[k];
      }
    }
  }
  this.sign = setCalcuMd5Str(this);
  if (options) {
    for (var k in options) {
      if (inExtList(k, extList)) {
        this[k] = options[k];
      }
    }
  }
  this.sessionid = getSessionId();
}

export var loading = function () { }
loading.show = function () {
  let node1 = document.createElement('div');
  node1.setAttribute('class', 'loading-component');
  let node2 = document.createElement('div');
  node2.setAttribute('class', 'loading-box');
  let node_span = []
  for (let i = 1; i <= 6; i++) {
    node_span[i] = document.createElement('span');
    node_span[i].setAttribute('class', 'loading-item loading-item' + i);
    node2.appendChild(node_span[i]);
  }
  node1.appendChild(node2);
  document.body.appendChild(node1);
}
loading.hide = function () {
  var loadStr = document.getElementsByClassName('loading-component')[0];
  if (loadStr) {
    document.body.removeChild(loadStr);
  }
}

//获取cookie
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}
//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, exdate) {
  document.cookie = c_name + "=" + escape(value) + ((exdate == null) ? "" : ";expires=" + exdate.toGMTString());
}
//删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
export function setSessionId(sessionId) {
  var exdate = new Date();
  exdate.setTime(exdate.getTime() + 10 * 24 * 60 * 60 * 1000);
  setCookie('session', sessionId, exdate)
}
export function getSessionId() {
  var sessonId = getCookie("session");
  return sessonId === null ? "" : sessonId;
}
export function getComputeSize(size) {
  if (size <= 1024) {
    return '<1K';
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(1) + 'K';
  } else {
    return (size / (1024 * 1024)).toFixed(1) + 'M';
  }
}
export function getTagName(tag_id, tagList) {
  if (tagList.length > 0) {
    for (var i = 0; i < tagList.length; i++) {
      if (tagList[i].id === tag_id) {
        return tagList[i].name;
      }
    }
  }
}

export function getDateFormat(time) {
  if (!time) {
    return '';
  }
  var date = new Date(time);
  return date.getFullYear()
    + "-" + ((date.getMonth() + 1 + "").length == 1 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + '')
    + "-" + ((date.getDate() + "").length == 1 ? '0' + date.getDate() : date.getDate() + '')
    + " " + ((date.getHours() + "").length == 1 ? '0' + date.getHours() : date.getHours() + '')
    + ":" + ((date.getMinutes() + "").length == 1 ? '0' + date.getMinutes() : date.getMinutes() + '')
}



// WEBPACK FOOTER //
// ./src/util/util.js